import { useQuery } from "@tanstack/react-query";
import {
  getMapOverlay,
  GetMapOverlayInput,
  getMapOverlayVersions,
  GetMapOverlayVersionsInput,
} from "@/map/api/requests/overlay.requests.ts";
import { MapOverlayApiResponse, MapOverlayVersionsApiResponse } from "@/map/types/overlay.ts";
import { QUERY_KEYS } from "@/map/api/config.ts";

export const useGetMapOverlay = (params: GetMapOverlayInput) => {
  return useQuery<MapOverlayApiResponse>({
    queryKey: [QUERY_KEYS.MAP_OVERLAY, params.location_id, params.version],
    queryFn: () => getMapOverlay(params),
    enabled: !!params.location_id,
    staleTime: 1000 * 60 * 60 * 12, // 12 hours - data considered fresh
    gcTime: 1000 * 60 * 60 * 24, // 24 hours - keep in cache
  });
};

export const useGetMapOverlayVersions = (params: GetMapOverlayVersionsInput) => {
  return useQuery<MapOverlayVersionsApiResponse>({
    queryKey: [QUERY_KEYS.MAP_OVERLAY_VERSIONS, params.location_id],
    queryFn: () => getMapOverlayVersions(params),
    enabled: !!params.location_id,
    staleTime: 1000 * 60 * 60 * 12, // 12 hours - data considered fresh
    gcTime: 1000 * 60 * 60 * 24, // 24 hours - keep in cache
  });
};
